import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router'
import { WebsocketService } from '../services/websocket.service'
import { HelperService } from '../services/helper.service'
import { getLoggedUser, setLoggedUser } from '../_helpers/LocalStorage'
import { UserService } from '../services/user.service'
import { UserAdmin } from '../models/UserAdmin'
import { NotificationService } from '../services/notification.service'

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

	constructor(
		private router: Router,
		private webSocketService: WebsocketService,
		private helper: HelperService,
		private notificationService: NotificationService,
		private userService: UserService
	) { }

	public static alreadyConnectedInWebsocket = false
	private lastGetMe = new Date()

	public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

		const access_token = JSON.parse(localStorage.getItem('access_token'))
		const currentUser: UserAdmin = getLoggedUser()

		const routeActual = route.routeConfig.path

		const wasDisconnectedByLimitReachedOnWebsocketConnection = Boolean(localStorage.getItem('limitConnectionReached'))
		if (access_token && routeActual == 'login' && !wasDisconnectedByLimitReachedOnWebsocketConnection) {
			this.router.navigate(['/redirect'])
			return
		}

		if (routeActual == 'login') {
			return true
		}

		if (routeActual == 'panel') {
			return true
		}

		if (routeActual == 'redirect') {
			return true
		}

		if ((access_token == null || access_token == undefined || !access_token) && routeActual != 'login') {
			this.router.navigate(['/login'])
			return false
		}

		// Authentication Helper
		if (access_token && currentUser) {

			if (!this.helper.getAlreadyConnectedInWebsocket() ) {
				this.helper.setAlreadyConnectedInWebsocket(true)
				await this.webSocketService.accessWebSocket()
			}

			// 15 minutes delay between Get Me
			if (this.lastGetMe.getTime() < (new Date().getTime() - 900000)) {
				this.lastGetMe = new Date()
				this.userService.getMe().subscribe(user => {
					setLoggedUser(user)
				})
			}
		}

		const subModules: Array<string> = currentUser.subModules

		const roles: Array<string> = currentUser && currentUser.roles
		const isAdmin = roles.includes('GENERAL_ADMIN')
		const isBotanic = roles.includes('BOTANIC')

		if (isAdmin) {
			return true
		}

		if (isBotanic) {
			return this.helper.validateBotanicRoutes(routeActual)
		}

		const routeIsPublic = this.helper.getPublicRoutes().some(rota => routeActual.includes(rota))

		if (routeIsPublic) {
			return true
		}

		// Se tem permissionamento na rota e a rota não é protegida para usuários administradores
		const hasPermissionRoutes =
			this.helper.getSubModulesForRoutes(routeActual).some(subModule => subModules.includes(subModule))

		if (hasPermissionRoutes)  {
			return true
		} else {
			this.notificationService.notify('Você não tem permissão para acessar esse recurso', 400)
			this.router.navigate(['/redirect'])
			return false
		}
	}

	public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
		return this.canActivate(childRoute, state)
	}
}
